import { Splide } from '@splidejs/splide';

class FabricSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // console.log('✅ FabricSlider component initialized.');

    this.splide = new Splide(this, {
      type: 'fade',
      arrows: true, // Enable arrows until client provides icons
      pagination: false, // Disable default pagination when client provides icons
      autoplay: true,
      interval: 5000,
      // Desktop
      breakpoints: {
        1024: {
          pagination: true,
          arrows: false
        }
      }
    }).mount();

    this.setupCustomPagination();
  }

  setupCustomPagination() {
    // Select all slides inside THIS slider
    const slides = this.querySelectorAll('.splide__slide');

    if (!slides.length) {
      // console.error('❌ No slides found inside this slider.');
      return;
    }

    slides.forEach((slide, slideIndex) => {
      const paginationContainer = slide.querySelector('.fabric-pagination');

      if (!paginationContainer) {
        // console.warn(`⚠️ No pagination container found in slide ${slideIndex}.`);
        return;
      }

      const paginationButtons = paginationContainer.querySelectorAll('.fabric-pagination-btn');

      // console.log(`✅ Slide ${slideIndex}: Found ${paginationButtons.length} pagination buttons.`);

      if (!paginationButtons.length) {
        // console.warn(`⚠️ Slide ${slideIndex}: No pagination buttons found.`);
        return;
      }

      paginationButtons.forEach((button, buttonIndex) => {
        // console.log(`🔹 Slide ${slideIndex}: Button ${buttonIndex} initialized.`);

        button.addEventListener('click', () => {
          // console.log(`🖱 Slide ${slideIndex}: Button ${buttonIndex} clicked. Moving to slide ${buttonIndex}.`);
          this.splide.go(buttonIndex);
        });
      });
    });

    // Ensure only the active slide's pagination buttons are updated
    this.splide.on('move', (newIndex) => {
      // console.log(`➡️ Slide moved to: ${newIndex}`);

      slides.forEach((slide, slideIndex) => {
        const paginationContainer = slide.querySelector('.fabric-pagination');
        if (!paginationContainer) return;

        const paginationButtons = paginationContainer.querySelectorAll('.fabric-pagination-btn');

        paginationButtons.forEach((button, idx) => {
          if (idx === newIndex) {
            // console.log(`🎯 Slide ${slideIndex}: Setting active class on button ${idx}`);
            button.classList.add('is-active');
          } else {
            button.classList.remove('is-active');
          }
        });
      });
    });

    // Set initial active button for the first slide
    slides[0]?.querySelector('.fabric-pagination-btn')?.classList.add('is-active');
  }
}

customElements.define('fabric-slider', FabricSlider);
